import { meApiMeGet, UserSession } from '@/api/client';
import { useApiQueryNoParams } from '@/lib/react-query';

/**
 * Query key for the current user session data
 * Used to properly cache and invalidate user data in React Query
 */
export const meQueryKey = ['me'] as const;

/**
 * React Query hook for the current user session (`GET /me`).
 * Passes AbortSignal so in-flight requests cancel on unmount or invalidation.
 */
export const useMe = (
  options?: Omit<
    Parameters<typeof useApiQueryNoParams<UserSession>>[0],
    'queryKey' | 'apiFn'
  >
) => {
  return useApiQueryNoParams({
    queryKey: meQueryKey,
    apiFn: meApiMeGet,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: false, // Never retry - auth failures should fail fast
    refetchOnWindowFocus: false, // Avoid refetch on tab focus so login/magic-link countdown state is not lost when user switches to email and back
    ...options,
  });
};
